// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.char-count[data-v-5534ef50] {\n  position: absolute;\n  right: 11px;\n  bottom: 2px;\n  font-size: 10px;\n  color: #909399;\n  line-height: 1;\n  pointer-events: none;\n  z-index: 5;\n}\n.char-count--inline[data-v-5534ef50] {\n  position: static;\n  margin-left: auto;\n  padding-left: 8px;\n  pointer-events: auto;\n}\n", ""]);
// Exports
module.exports = exports;
